/**
 * String-literal unions aligned with `schema.sql` enums (source of truth).
 * @see ADR-003 — Drizzle maps the full schema; these types stay in sync for app code.
 */
export const ENTITY_TYPES = ["dispensary", "transporter", "platform", "customer"];
export const USER_ROLES = [
    "platform_admin",
    "dispensary_dispatcher",
    "dispensary_budtender",
    "transporter_dispatcher",
    "driver",
    "customer",
];
export const ORDER_STATUSES = [
    "pending",
    "confirmed",
    "dispatched",
    "in_progress",
    "completed",
    "cancelled",
    "failed",
];
export const RUN_STATUSES = [
    "proposed",
    "driver_assigned",
    "driver_confirmed",
    "en_route_to_dispensary",
    "at_dispensary",
    "out_for_delivery",
    "completed",
    "voided",
];
export const STOP_STATUSES = [
    "pending",
    "out_for_delivery",
    "delivered",
    "failed",
    "returned",
];
export const MANIFEST_STATUSES = [
    "pending",
    "submitted",
    "active",
    "completed",
    "voided",
];
export const TRANSFER_STATUSES = [
    "pending",
    "processing",
    "completed",
    "failed",
    "reversed",
];
export const BATCH_STATUSES = [
    "accumulating",
    "pending_approval",
    "approved",
    "processing",
    "settled",
    "failed",
];
export const FEE_TYPES = [
    "flat_per_delivery",
    "per_mile",
    "percentage_of_order",
];
export const DELIVERY_SOURCES = [
    "platform_web",
    "dutchie_ecommerce",
    "pos_webhook",
    "manual_entry",
];
export const METRC_CALL_TYPES = ["read", "write"];
export const ONBOARDING_STEPS = [
    "kyb_verification",
    "bank_account_linking",
    "fee_schedule_agreement",
    "vehicle_registration",
    "driver_registration",
    "completed",
];
//# sourceMappingURL=enums.js.map